/* istanbul ignore file */

import { Field } from '../services/logic-services/models';
import { ReportView } from './report-view-model';
import { Role } from './role';

export class ReportDefinition {
    id: string;
    aggregateBy?: string;
    projectId: string;
    projId: string;
    name: string;
    active: boolean;
    dateCreated: string;
    createdBy: string;
    description?: string;
    JSONForms?: any;
    reportType: string;
    roles?: Role[];
    role: Role;
    selectedFields: any[];
    autoSelectedFields?: Field[];
    isSaving = false;
    customViews: ReportView[];
    enableSubRow: boolean;
}
